import React from 'react'

import { Radio } from '@gousto-internal/citrus-react'
import classnames from 'classnames'

import { ItemContent } from './RecipeOptionsItemContent'

import css from './RecipeOptionsItem.css'

type RecipeOptionsItemProps = {
  recipeId: string
  recipeName: string
  changeCheckedRecipe: () => void
  isChecked: boolean
  isOutOfStock: boolean
  surcharge?: number | null
}

export const RecipeOptionsItem = ({
  recipeId,
  recipeName,
  changeCheckedRecipe,
  isChecked,
  isOutOfStock,
  surcharge = null,
}: RecipeOptionsItemProps) => (
  <li className={classnames(css.listItem, { [css.listItemChecked]: isChecked })}>
    <Radio
      id={recipeId}
      value={recipeId}
      name="variantList"
      onChange={changeCheckedRecipe}
      checked={isChecked}
      style={{ width: '100%' }}
    >
      {() => (
        <ItemContent
          recipeName={recipeName}
          isOutOfStock={isOutOfStock}
          surcharge={surcharge}
          isChecked={isChecked}
        />
      )}
    </Radio>
  </li>
)
